import types from '../constants'

const initialState = {
  isShow: false,
  alertType: types.ERROR,
  alertMessage: "",
  // timeout: 2 //in seconds
}

export default function alertNotification(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_ALERT_ERROR:
      return {
        ...state,
        isShow: true,
        alertType: types.ERROR,
        alertMessage: action.payload.alertMessage
      }
    case types.SHOW_ALERT_SUCCESS:
      return {
        ...state,
        isShow: true,
        alertType: types.SUCCESS,
        alertMessage: action.payload.alertMessage
      }
    case types.CLOSE_ALERT:
      return {
        ...state,
        isShow: false,
      }
    default:
      return {
        ...state,
      }
  }
}
